window.shouldRedirectToCartPage = () => window.themeCartSettings?.addBehavior === 'page';

function refreshCartJS() {
  if (document.body?.classList?.contains('template--landing-without-header')) {
    window.location.assign(window.routes?.cart_url || '/cart');
    return;
  }
  const cartSlide = document.querySelector('cart-slide');
  if (cartSlide) {
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    if (!window.shouldRedirectToCartPage() && cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    if (window.shouldRedirectToCartPage()) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }
    refreshCartJS();
    if (openCart) {
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}

/* QA r2 #59 live parity: Back to top (ported from live custom.js) */
// (function () {
//     'use strict';
//     var goTopBtn = document.querySelector('.back-to-top');
//     if (!goTopBtn) return;
//     function trackScroll() {
//         var scrolled = window.pageYOffset;
//         var coords = document.documentElement.clientHeight;
//         if (scrolled > coords) goTopBtn.classList.add('back-to-top--show');
//         if (scrolled < coords) goTopBtn.classList.remove('back-to-top--show');
//     }
//     function backToTop() {
//         if (window.pageYOffset > 0) {
//             window.scrollBy(0, -80);
//             setTimeout(backToTop, 0);
//         }
//     }
//     window.addEventListener('scroll', trackScroll);
//     goTopBtn.addEventListener('click', backToTop);
// })();

(function () {
    'use strict';
    var goTopBtn = document.querySelector('.back-to-top');
    if (!goTopBtn) return;

    var ticking = false;

    function updateButton() {
        var show = window.pageYOffset > document.documentElement.clientHeight;
        goTopBtn.classList.toggle('back-to-top--show', show);
        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateButton);
        }
    }

    function backToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    goTopBtn.addEventListener('click', backToTop);
    updateButton();
})();

/* QA r3 #67 live parity: search expand (ported from live custom.js) - toggles body.custom-search-open (overlay + modal styles in custom.css) */
(function () {
  var searchBox = document.getElementById('js-search-toggle');
  var searchInput = document.getElementById('js-search-input');
  var closeBtn = document.querySelector('.close-search-popup');
  if (!searchBox) return;
  searchBox.addEventListener('click', function () {
    document.body.classList.add('custom-search-open');
    if (searchInput) searchInput.focus();
  });
  if (closeBtn) closeBtn.addEventListener('click', function () {
    document.body.classList.remove('custom-search-open');
  });
})();
